import React, { useContext } from 'react';
import { useLocation } from 'react-router';

import PropTypes from 'prop-types';

import { WishListContext } from 'Context/Wishlist';

// DS
import { Col, Row, VertTypography, VertIcon, VertWishlist, VertLoading, notification } from '@vertem-core/vertice-ds';
import { DeleteOutlined } from '@ant-design/icons';

// SERVICES
import { useDispatch } from 'react-redux';

import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';
import { addToWishListThunk, removeFromWishListThunk } from 'redux/Reducers/WishList/WishListSlice';

// STYLES
import 'Assets/styles/default/components/Cart/CartItemActionButtonsStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import {useCartItem} from "components/Cart/CartContent/CartItemList/CartItemProvider";

// CART ITEM ACTION BUTTONS COMPONENT
const CartItemActionButtons = ({ isFavorited, onlyIcons, sku, isLoading }) => {
  /* Hooks */
  const { callApi } = usePipeContext()
  const { updateWishList, updateSimpleWishList } = useContext(WishListContext);
  const { SetRemoveFromCartInGA, SetFavoriteInGA } = useCartItem()

  const location = useLocation();
  const dispatch = useDispatch();

  const shouldUpdateCompleteWishList = () => {
    if (location.pathname == "/wishlist") updateWishList();
  }

  /* Handlers */
  const handleWishListToggle = async (productSku) => {
    try {
      const isProductInWishList = isFavorited;

      if (SetFavoriteInGA) SetFavoriteInGA();

      isProductInWishList
        ? await dispatch(removeFromWishListThunk(productSku)).unwrap()
        : await dispatch(addToWishListThunk(productSku)).unwrap();

      updateSimpleWishList();
      shouldUpdateCompleteWishList();
    } catch (err) {
      console.log(err)

      notification.error({
        message: "Houve um erro ao favoritar o produto, tente novamente mais tarde.",
      });
    }
  }

  const handleDeleteItem = ( sku ) => {
    const deleteAlias = (generateUUID());
    if (SetRemoveFromCartInGA) SetRemoveFromCartInGA()
    callApi({
      symbol: `DELETE_ITEM_CART`,
      alias: deleteAlias,
      payload: {
        sku: sku
      }
    })
  };

  /* Renders */
  return (
    <Col data-testid="cart-actions-buttons" className="cart-item-action-buttons">
      <Row className='delete-action' verticalSpacing="none" onClick={() => handleDeleteItem(sku)}>
        {isLoading && <VertLoading size='small' />}
        {!isLoading && (
          <>
            <VertIcon component={DeleteOutlined} aria-label={`Remover produto do carrinho`} />
            <VertTypography.Paragraph >
              {onlyIcons ? '' : 'Excluir'}
            </VertTypography.Paragraph>
          </>
        )}
      </Row>

      <VertWishlist
        className="favorite-action"
        favorited={isFavorited}
        label={onlyIcons ? '' : 'Favoritar'}
        onClick={() => handleWishListToggle(sku)}
      />
    </Col>
  );
};

CartItemActionButtons.propTypes = {
  isFavorited: PropTypes.bool,
  onlyIcons: PropTypes.bool,
  isLoading: PropTypes.bool,
  sku: PropTypes.string.isRequired
};

export default CartItemActionButtons;
